(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aeocky-mobile-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ae-mobile-navigation')) {
    class AeMobileNavigation extends HTMLElement {
      constructor() {
        super();

        this.handleOpen = () => this.open();
        this.handleClose = () => this.close();
        this.handleBack = () => this.showRoot();
        this.handleClick = this.onClick.bind(this);
        this.handleCategoryToggle = this.onCategoryToggle.bind(this);
        this.handleKeyDown = this.onKeyDown.bind(this);
        this.handleMediaChange = (event) => {
          if (!event.matches) this.close(false);
        };
        this.focusFrame = 0;
      }

      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.drawer = this.querySelector('[data-ae-mobile-drawer]');
        this.root = this.querySelector('[data-ae-mobile-nav-root]');
        this.backButton = this.querySelector('[data-ae-mobile-nav-back]');
        this.brand = this.querySelector('[data-ae-mobile-nav-brand]');
        this.panelTitle = this.querySelector('[data-ae-mobile-nav-title]');
        this.viewport = this.querySelector('[data-ae-mobile-nav-viewport]');
        this.toggle = document.querySelector(`[aria-controls="${this.drawer.id}"]`);
        this.closeButtons = Array.from(this.querySelectorAll('[data-ae-mobile-nav-close]'));
        this.mediaQuery = window.matchMedia('(max-width: 1024px)');

        this.toggle?.addEventListener('click', this.handleOpen);
        this.closeButtons.forEach((button) => button.addEventListener('click', this.handleClose));
        this.backButton?.addEventListener('click', this.handleBack);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('toggle', this.handleCategoryToggle, true);
        document.addEventListener('keydown', this.handleKeyDown);
        this.mediaQuery.addEventListener('change', this.handleMediaChange);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.handleOpen);
        this.closeButtons?.forEach((button) => button.removeEventListener('click', this.handleClose));
        this.backButton?.removeEventListener('click', this.handleBack);
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('toggle', this.handleCategoryToggle, true);
        document.removeEventListener('keydown', this.handleKeyDown);
        this.mediaQuery?.removeEventListener('change', this.handleMediaChange);

        if (this.focusFrame) cancelAnimationFrame(this.focusFrame);

        if (this.classList.contains('is-open')) {
          document.body.classList.remove('ae-mobile-nav-open');
          this.toggle?.setAttribute('aria-expanded', 'false');
        }

        this.focusFrame = 0;
        delete this.dataset.initialized;
      }

      queueFocus(callback) {
        if (this.focusFrame) cancelAnimationFrame(this.focusFrame);

        this.focusFrame = requestAnimationFrame(() => {
          this.focusFrame = 0;
          if (this.isConnected) callback();
        });
      }

      open() {
        if (!this.mediaQuery.matches) return;

        this.lastActiveElement = document.activeElement;
        this.classList.add('is-open');
        this.drawer.inert = false;
        this.drawer.setAttribute('aria-hidden', 'false');
        this.toggle?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('ae-mobile-nav-open');
        this.queueFocus(() => this.querySelector('[data-ae-mobile-nav-close]')?.focus());
      }

      close(returnFocus = true) {
        if (this.focusFrame) {
          cancelAnimationFrame(this.focusFrame);
          this.focusFrame = 0;
        }

        this.classList.remove('is-open');
        this.drawer.inert = true;
        this.drawer.setAttribute('aria-hidden', 'true');
        this.toggle?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('ae-mobile-nav-open');
        this.showRoot();

        if (returnFocus) this.lastActiveElement?.focus();
      }

      showRoot() {
        this.root.hidden = false;
        this.querySelectorAll('[data-ae-mobile-panel]').forEach((panel) => {
          panel.hidden = true;
        });
        this.backButton.hidden = true;
        this.brand.hidden = false;
        this.panelTitle.hidden = true;
        this.viewport.scrollTop = 0;
      }

      showPanel(button) {
        const panel = this.querySelector(`[data-ae-mobile-panel="${CSS.escape(button.dataset.aeMobilePanelTarget)}"]`);
        if (!panel) return;

        this.root.hidden = true;
        this.querySelectorAll('[data-ae-mobile-panel]').forEach((candidate) => {
          candidate.hidden = candidate !== panel;
        });
        this.backButton.hidden = false;
        this.brand.hidden = true;
        this.panelTitle.hidden = false;
        this.panelTitle.textContent = panel.dataset.aeMobilePanelTitle || '';
        this.viewport.scrollTop = 0;
        this.queueFocus(() => this.backButton.focus());
      }

      onClick(event) {
        const panelButton = event.target.closest('[data-ae-mobile-panel-target]');
        if (panelButton && this.contains(panelButton)) {
          this.showPanel(panelButton);
          return;
        }

        const link = event.target.closest('a');
        if (link && this.contains(link)) this.close(false);
      }

      onCategoryToggle(event) {
        const category = event.target.closest?.('.ae-mobile-navigation__category');
        if (!category || !this.contains(category) || !category.open) return;

        const group = category.closest('.ae-mobile-navigation__categories');
        if (!group) return;

        group.querySelectorAll('.ae-mobile-navigation__category[open]').forEach((candidate) => {
          if (candidate !== category) candidate.open = false;
        });
      }

      onKeyDown(event) {
        if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
      }
    }

    customElements.define('ae-mobile-navigation', AeMobileNavigation);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-linklists"] && !Shopify.designMode) return;
  try {
    if (!window.aeockyLinklistMegaMenuPositioner) {
    window.aeockyLinklistMegaMenuPositioner = true;

    const updateAeockyLinklistMegaMenu = (details) => {
      const menu = details && details.querySelector('.mega-menu--linklists-builder');
      const summary = details && details.querySelector('summary');

      if (!menu || !summary) {
        return;
      }

      const margin = 12;
      const anchorLeft = Math.round(summary.getBoundingClientRect().left);
      const panel = menu.querySelector('.mega-menu-linklists');

      if (!panel) {
        return;
      }

      const padding = parseFloat(getComputedStyle(panel).paddingLeft) || 34;
      const preferredOffset = Math.max(margin, anchorLeft - padding);
      const preferredWidth = Math.min(490, Math.max(340, window.innerWidth - preferredOffset - margin));

      menu.style.setProperty('--ae-linklist-anchor-left', `${anchorLeft}px`);
      menu.style.setProperty('--ae-linklist-content-offset', `${preferredOffset}px`);
      menu.style.setProperty('--ae-linklist-panel-width', `${Math.round(preferredWidth)}px`);

      requestAnimationFrame(() => {
        const rect = panel.getBoundingClientRect();
        let offset = preferredOffset;

        if (rect.right > window.innerWidth - margin) {
          offset -= rect.right - (window.innerWidth - margin);
        }

        if (offset < margin) {
          offset = margin;
        }

        menu.style.setProperty('--ae-linklist-content-offset', `${Math.round(offset)}px`);
      });
    };

    const scheduleAeockyLinklistMegaMenu = (target) => {
      const details = target && target.closest && target.closest('.ae-header-nav-parent--linklists');

      if (details) {
        updateAeockyLinklistMegaMenu(details);
      }
    };

    document.addEventListener('pointerover', (event) => scheduleAeockyLinklistMegaMenu(event.target), true);
    document.addEventListener('focusin', (event) => scheduleAeockyLinklistMegaMenu(event.target), true);
    document.addEventListener('toggle', (event) => {
      if (event.target && event.target.matches && event.target.matches('.ae-header-nav-parent--linklists[open]')) {
        updateAeockyLinklistMegaMenu(event.target);
      }
    }, true);
    window.addEventListener('resize', () => {
      document.querySelectorAll('.ae-header-nav-parent--linklists[open]').forEach(updateAeockyLinklistMegaMenu);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-product-tabs-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-tabs-mega-menu')) {
    class ProductTabsMegaMenu extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-product-tab]'));
        this.menu = this.closest('.mega-menu--product-tabs');
        this.disclosure = this.closest('details');
        this.updateMenuHeight = this.updateMenuHeight.bind(this);
        this.addEventListener('pointerover', this.onPointerOver.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('focusin', this.onFocusIn.bind(this));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
        window.addEventListener('resize', this.updateMenuHeight);
        this.disclosure?.addEventListener('toggle', this.updateMenuHeight);
        requestAnimationFrame(this.updateMenuHeight);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateMenuHeight);
        this.disclosure?.removeEventListener('toggle', this.updateMenuHeight);
      }

      updateMenuHeight() {
        const menu = this.menu;
        if (!menu || window.innerWidth < 1025) return;

        const height = Math.max(0, window.innerHeight * 0.7 - menu.getBoundingClientRect().top);
        menu.style.setProperty('--product-tabs-menu-height', `${Math.round(height)}px`);
      }

      onPointerOver(event) {
        if (!window.matchMedia('(pointer: fine)').matches) return;

        const tab = event.target.closest('[data-product-tab]');
        if (tab && this.contains(tab)) this.activate(tab);
      }

      onClick(event) {
        const tab = event.target.closest('[data-product-tab]');
        if (tab && this.contains(tab)) this.activate(tab);
      }

      onFocusIn(event) {
        const tab = event.target.closest('[data-product-tab]');
        if (tab && this.contains(tab)) this.activate(tab);
      }

      onKeyDown(event) {
        const currentTab = event.target.closest('[data-product-tab]');
        if (!currentTab) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex;

        if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        this.activate(this.tabs[nextIndex], true);
      }

      activate(tab, moveFocus = false) {
        this.tabs.forEach((candidate) => {
          const isActive = candidate === tab;
          const panel = this.querySelector(`#${CSS.escape(candidate.getAttribute('aria-controls'))}`);

          candidate.classList.toggle('is-active', isActive);
          candidate.setAttribute('aria-selected', String(isActive));
          candidate.tabIndex = isActive ? 0 : -1;
          if (panel) panel.hidden = !isActive;
        });

        if (moveFocus) tab.focus();
      }
    }

    customElements.define('product-tabs-mega-menu', ProductTabsMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-tabs-mega-menu')) {
    class ProductTabsMegaMenu extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-product-tab]'));
        this.menu = this.closest('.mega-menu--product-tabs');
        this.disclosure = this.closest('details');
        this.updateMenuHeight = this.updateMenuHeight.bind(this);
        this.addEventListener('pointerover', this.onPointerOver.bind(this));
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('focusin', this.onFocusIn.bind(this));
        this.addEventListener('keydown', this.onKeyDown.bind(this));
        window.addEventListener('resize', this.updateMenuHeight);
        this.disclosure?.addEventListener('toggle', this.updateMenuHeight);
        requestAnimationFrame(this.updateMenuHeight);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateMenuHeight);
        this.disclosure?.removeEventListener('toggle', this.updateMenuHeight);
      }

      updateMenuHeight() {
        const menu = this.menu;
        if (!menu || window.innerWidth < 1150) return;

        const height = Math.max(0, window.innerHeight * 0.7 - menu.getBoundingClientRect().top);
        menu.style.setProperty('--product-tabs-menu-height', `${Math.round(height)}px`);
      }

      onPointerOver(event) {
        if (!window.matchMedia('(pointer: fine)').matches) return;

        const tab = event.target.closest('[data-product-tab]');
        if (tab && this.contains(tab)) this.activate(tab);
      }

      onClick(event) {
        const tab = event.target.closest('[data-product-tab]');
        if (tab && this.contains(tab)) this.activate(tab);
      }

      onFocusIn(event) {
        const tab = event.target.closest('[data-product-tab]');
        if (tab && this.contains(tab)) this.activate(tab);
      }

      onKeyDown(event) {
        const currentTab = event.target.closest('[data-product-tab]');
        if (!currentTab) return;

        const currentIndex = this.tabs.indexOf(currentTab);
        let nextIndex;

        if (event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === undefined) return;

        event.preventDefault();
        this.activate(this.tabs[nextIndex], true);
      }

      activate(tab, moveFocus = false) {
        this.tabs.forEach((candidate) => {
          const isActive = candidate === tab;
          const panel = this.querySelector(`#${CSS.escape(candidate.getAttribute('aria-controls'))}`);

          candidate.classList.toggle('is-active', isActive);
          candidate.setAttribute('aria-selected', String(isActive));
          candidate.tabIndex = isActive ? 0 : -1;
          if (panel) panel.hidden = !isActive;
        });

        if (moveFocus) tab.focus();
      }
    }

    customElements.define('product-tabs-mega-menu', ProductTabsMegaMenu);
  }
  } catch(e) { console.error(e); }
})();

})();
